import React from 'react';
import { motion } from 'framer-motion';
import slugify from 'slugify';
import MenuItem from './MenuItem';

const SubMenu = ({ items, level, parent, path, open }) => {
  return (
    <motion.div
      className={`Nav__submenu level-${level}`} data-identifier={path}
      key={`submenu_${path}`}
      initial="closed"
      animate="open"
      exit="closed"
      variants={{
        open: { opacity: 1, height: 'auto' },
        closed: { opacity: 0, height: 0 },
      }}
      transition={{ duration: 0.6, ease: [0.04, 0.62, 0.23, 0.98] }}
    >
      <div className="Nav" layout='vertical'>
        {
          items?.map((link, index) => {
            return (
              <MenuItem parent={parent} link={link} level={level + 1} key={link.name} path={`${path}_${slugify(link.name.toLowerCase())}`}></MenuItem>
            );
          })
        }
      </div>
    </motion.div>
  );
};

export default SubMenu